export const getTextFields = (userData: any) => [
    {
        id: "user-name",
        name: "name",
        label: "Name",
        type: "text",
        placeholder: "Enter Name",
        required: true,
        capitalizedFirst: true,
        value: userData?.admin?.name
    },
    {
        id: "user-phone",
        name: "phone",
        label: "Phone",
        type: "text",
        placeholder: "Enter Phone",
        required: true,
        value: userData?.phone,
    },
    {
        id: "user-email",
        name: "email",
        label: "Email Address",
        type: "text",
        placeholder: "Enter Email Address",
        required: true,
        value: userData?.email,
    },
    {
        label: "Role",
        value: userData?.userRole?.map((data : any)=> data?.role?.name),
        formField: false,
    },
    {
        label: "Gender",
        value: userData?.admin?.gender,
        formField: false,
    },
    {
        id: "user-password",
        name: "password",
        label: "Password",
        type: "password",
        placeholder: "Enter Password",
        required: true,
        formField: Object.keys(userData).length > 0 ? false : true,
        value: null
    },
];